import {Component, OnDestroy, OnInit} from '@angular/core';

import {Subscription} from 'rxjs';

import {CertificatedService} from './certificated.service';

@Component({
  selector: 'app-certificated',
  templateUrl: './certificated.component.html'
})
export class CertificatedComponent implements OnInit, OnDestroy {

  errorSubscription?: Subscription;

  pluginNotFound?: boolean;

  constructor(
    private certificatedService: CertificatedService
  ) {
  }

  ngOnInit(): void {
    this.errorSubscription = this.certificatedService.errorSubject.subscribe(error => {
      if (error) {
        if (error.status === 0) {
          this.pluginNotFound = true;
        }
        console.log(error);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.errorSubscription) {
      this.errorSubscription.unsubscribe();
    }
  }

}
